import {ErrorBoundary} from '@sentry/react'

import {Block} from '../Block'
import {PagePullout} from './PagePullout'
import {BlockError} from '../Block/BlockError'

import type {XcNwBlockFragment} from '@sdox/api'

export interface PageBlocksTemplate {
  /*  set this value to false in order to avoid the top pullout on the block (ex. PageHeading is available) */
  allowTopPullout?: boolean
  blocks: XcNwBlockFragment[]
}

export const PageBlocksTemplate = ({
  allowTopPullout = true,
  blocks,
}: PageBlocksTemplate) => (
  <>
    {blocks.map((block, index, arr) => {
      const isFirstBlock = index === 0
      const isLastBlock = index === arr.length - 1

      return (
        <ErrorBoundary
          key={block.id}
          fallback={(
            <PagePullout>
              <BlockError />
            </PagePullout>
          )}
        >
          <PagePullout
            top={block.pullout && isFirstBlock && allowTopPullout}
            left={block.pullout}
            right={block.pullout}
            bottom={block.pullout && isLastBlock}
          >
            <Block {...block} />
          </PagePullout>
        </ErrorBoundary>
      )
    })}
  </>
)
